import React from 'react';
import Header from "./Header"
import { Link } from "react-router-dom"

function TermsOfService( data ) {
  return (
    <div className="gameTypesMainHolder">
      <Header headerContext='privacyPolicy'
      user={ data.user }
      logout={ data.logout }
      toggleGetChips={ data.toggleGetChips }
      width = { data.width }
      showSiteMenu = { data.showSiteMenu }
      toggleSiteMenu = { data.toggleSiteMenu }/>
      <div className='textContentHolder'>
      <h1>Terms of Service</h1>
        <dl className="list">
          <dt>Definitions</dt>
          <p>"Account" means the account you create when accessing the Service.</p>
          <p>"Service" means our games, products, services, and content operated by PokerStream.</p>
          <p>"Terms of Service" or "Terms" means these terms of service.</p>
          <p>"Virtual Items" means virtual currency used in the Services and virtual in-game items.</p>
        </dl>
        <dl className="list">
          <dt>Changes to these terms</dt>
          <p>We reserve the right to change, update, or delete any part of the Terms, Community Guidelines, or Conditions as we see fit.</p>
          <p>You cannot alter the Terms without a written agreement from PokerStream.</p>
          <p>For any disputes with PokerStream, we will use the version of the Terms, that were in place when we received notice of the dispute.</p>
          <p>These Terms override any other terms or rules of PokerStream that may conflict with them.</p>
        </dl>
        <dl className="list">
          <dt>Account Information and Security</dt>
          <p>We don't provide personal accounts.</p>
        </dl>
        <dl className="list">
          <dt>Who can use our Services</dt>
          <p>The terms of service for PokerStream state that you must be at least 18 years old to use their services. Additionally, you are not allowed to use services if you are a convicted offender.</p>
        </dl>
        <dl className="list">
          <dt>Access to our Services</dt>
          <p>You can enjoy playing games on PokerStream without the need for registration. However, certain features, such as saving progress or purchasing Virtual Items, may require an account.</p>
        </dl>

        <dl className="list">
          <dt>Rule of ownership; limited license</dt>
          <p>PokerStream Services are products created by PokerStream and protected by copyright, trademark, and other intellectual property laws. You do not acquire any rights to the Services or their content unless we have granted you such an opportunity.</p>
        </dl>
        <dl className="list">
          <dt>Your relationship with other players</dt>
          <p>It is important that you treat other players with respect. We do not promise that we will regulate your conflicts with other players, but we reserve the right to do so at our discretion and will not reimburse any damages.</p>
        </dl>
        <dl className="list">
          <dt>Feedback and volunteered ideas</dt>
          <p>We value your opinion about our features and would like to know what you think about them. We may ask you to share your experiences through a promotion or customer satisfaction survey program. Your participation is voluntary and does not affect your use of our features. Everything you tell us will be protected and will not be disclosed to third parties.</p>
        </dl>
        <dl className="list">
          <dt>Access to the service, disclaimer of warranty obligations</dt>
          <p>PokerStream Company does not undertake to provide uninterrupted, stable or secure access to the service or to any information contained therein. We have the right to suspend, remove or limit access to all or part of the Service for commercial or technical reasons. We are interested in your evaluation of our features and want to know your opinion about them. We may ask you to participate in an advertising campaign or user satisfaction survey. Your participation is voluntary and does not affect your use of our features. Your opinion will be kept confidential and will not be shared with third parties.</p>
        </dl>
        <dl className="list">
          <dt>Integrity of conditions</dt>
          <p>These Terms and any policies or rules they refer to are the entire and final agreement between you and us with respect to the subject matter of these Terms. They cancel and supersede all prior agreements between us relating to this subject matter, regardless of the form, manner or time of making or maintaining them.</p>
          <p>We will not indemnify you for any loss that may arise due to circumstances beyond our reasonable control. This could be anything related to the forces of nature, human conflict, government action, technical problems, labor disputes, or insufficient resources. We are not responsible for such situations and are not obliged to resolve them.</p>
        </dl>
      </div>
    </div>
  );
}

export default TermsOfService;